import styled from "styled-components";
import { glow } from "theme";

import dynBackgroundColor from "Utilities/interpolations/dynBackgroundColor";
import dynMarginRight from "Utilities/interpolations/dynMarginRight";

const ButtonSizer = styled.div`
  height: ${({ $size = 36 }) => $size}px;
  min-width: ${({ $size = 36 }) => $size}px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 18px;
  ${dynMarginRight}
  ${dynBackgroundColor}
  ${({ $glowColor }) => (!$glowColor ? "" : glow)}
  transition: background-color 300ms ease-in-out, height 300ms ease-in-out, min-width 300ms ease-in-out, margin-right 300ms ease-in-out;
`;

export default ButtonSizer;
